'use client';

import ClientFehlerSeite from '../../src/components/fehlerseite/ClientFehlerSeite';

/**
 * Fehlerseite der Single-Page-App — vor allem, wenn ihr Bündel nicht lädt
 * (`SpaHuelle` wirft den Ladefehler hierher). Mit Legal-Footer (Regel #21).
 */
export default function Fehler({ error }: { error: Error & { digest?: string } }) {
  return <ClientFehlerSeite error={error} />;
}
